import classNames from 'classnames'
import React, { LabelHTMLAttributes, ReactNode } from 'react'

interface FieldLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  text: ReactNode
  required?: boolean
}

export const FieldLabel = ({
  text,
  required,
  className,
  children,
  ...rest
}: FieldLabelProps) => (
  <label className={classNames('inputLabel text-base', className)} {...rest}>
    {text}
    {required && <span className="ml-1 text-orange">*</span>}
    {children}
  </label>
)
